import {
  DISCLAIMERS_ADD_ASYNC,
  DISCLAIMERS_REQUEST_ASYNC,
  DISCLAIMERS_UPDATE_ASYNC,
} from './constants'

export default function () {
  const initialState = {
    loader: false,
    disclaimerLoaderIds: [],
    disclaimers: [],
    error: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case DISCLAIMERS_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true }
      case DISCLAIMERS_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          disclaimers: action.payload.data.disclaimers,
          loader: false,
        }
      case DISCLAIMERS_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          loader: false,
        }
      case DISCLAIMERS_ADD_ASYNC.INITIATE: {
        const { disclaimers, disclaimerLoaderIds } = state
        const disclaimer = action.payload.disclaimer

        return {
          ...state,
          disclaimers: [...disclaimers, disclaimer],
          disclaimerLoaderIds: [...disclaimerLoaderIds, disclaimer.id],
        }
      }
      case DISCLAIMERS_ADD_ASYNC.SUCCESS:
        return {
          ...state,
          disclaimers: state.disclaimers.map((d) => ({
            ...d,
            id: d.id === action.payload.tempId ? action.payload.id : d.id,
          })),
          disclaimerLoaderIds: state.disclaimerLoaderIds.filter(
            (id) => id !== action.payload.tempId
          ),
        }
      case DISCLAIMERS_UPDATE_ASYNC.INITIATE: {
        const { disclaimers, disclaimerLoaderIds } = state
        const disclaimer = action.payload.disclaimer

        return {
          ...state,
          disclaimers: disclaimers.map((d) => ({
            ...d,
            text: d.id === disclaimer.id ? disclaimer.text : d.text,
          })),
          disclaimerLoaderIds: [...disclaimerLoaderIds, disclaimer.id],
        }
      }
      case DISCLAIMERS_UPDATE_ASYNC.SUCCESS: {
        return {
          ...state,
          disclaimers: state.disclaimers.map((d) => ({
            ...d,
            id: d.id === action.payload.id ? action.payload.id : d.id,
          })),
          disclaimerLoaderIds: state.disclaimerLoaderIds.filter((id) => id !== action.payload.id),
        }
      }

      case DISCLAIMERS_ADD_ASYNC.ERROR:
      case DISCLAIMERS_UPDATE_ASYNC.ERROR:
        return {
          ...state,
          error: action.error,
          disclaimerLoaderIds: [],
        }
      default:
        return state
    }
  }
}
